import React, { useState } from 'react';
import api from '../services/api';
import './LietSiManagement.css'; // Tái sử dụng CSS bảng

const XaTraCuu = () => {
    const [tenTn, setTenTn] = useState('');
    const [namSinhTn, setNamSinhTn] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!tenTn.trim()) {
            alert("Vui lòng nhập tên thân nhân");
            return;
        }

        setLoading(true);
        setSearched(true);
        try {
            const res = await api.get('/tracuu/search', {
                params: { ten_tn: tenTn, nam_sinh_tn: namSinhTn }
            });
            setResults(res.data);
        } catch (err) {
            alert('Lỗi khi tra cứu');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="liet-si-container">
            <h1>Tra cứu Thông tin Liệt sĩ (Dữ liệu Tham khảo)</h1>
            <p style={{fontStyle: 'italic', color: '#666'}}>
                Dữ liệu từ: Đơn vị thu mẫu & DC01 mở rộng.
            </p>

            <form onSubmit={handleSearch} className="search-box" style={{display: 'flex', gap: '10px', marginBottom: '20px'}}>
                <input 
                    type="text" 
                    placeholder="Nhập tên thân nhân (*)" 
                    value={tenTn}
                    onChange={(e) => setTenTn(e.target.value)}
                    style={{padding: '10px', width: '300px'}}
                />
                <input 
                    type="text" 
                    placeholder="Năm sinh (Tùy chọn)" 
                    value={namSinhTn}
                    onChange={(e) => setNamSinhTn(e.target.value)}
                    style={{padding: '10px', width: '150px'}}
                />
                <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Đang tìm...' : 'Tra cứu'}
                </button>
            </form>

            <div className="table-wrapper">
                <table className="crud-table">
                    <thead>
                        <tr>
                            <th>Nguồn dữ liệu</th>
                            <th>Họ tên Thân nhân</th>
                            <th>Năm sinh</th>
                            <th>Địa chỉ</th>
                            <th>Tên Liệt sĩ</th>
                            <th>Quan hệ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.length === 0 && searched && !loading && (
                            <tr><td colSpan="6" style={{textAlign: 'center'}}>Không tìm thấy kết quả nào.</td></tr>
                        )}
                        {results.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    {item.nguon_du_lieu === 'don_vi_thu_mau' 
                                        ? <span style={{color: 'blue', fontWeight: 'bold'}}>ĐV Thu Mẫu</span> 
                                        : <span style={{color: 'green', fontWeight: 'bold'}}>DC01 Mở rộng</span>}
                                </td>
                                <td>{item.ho_ten_tn}</td>
                                <td>{item.nam_sinh_tn}</td>
                                <td>{item.dia_chi_tn}</td>
                                <td style={{fontWeight: 'bold', color: '#d32f2f'}}>{item.ho_ten_ls}</td>
                                <td>{item.quan_he_voi_ls}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default XaTraCuu;